import { __assign, __rest } from "tslib";
import React from "react";
import VeltCommentBubbleAvatar from "./VeltCommentBubbleAvatar/VeltCommentBubbleAvatar";
import VeltCommentBubbleCommentsCount from "./VeltCommentBubbleCommentsCount/VeltCommentBubbleCommentsCount";
import VeltCommentBubbleUnreadIcon from "./VeltCommentBubbleUnreadIcon/VeltCommentBubbleUnreadIcon";
var VeltCommentBubbleWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-bubble-wireframe", __assign({}, remainingProp), children));
};
VeltCommentBubbleWireframe.Avatar = VeltCommentBubbleAvatar;
VeltCommentBubbleWireframe.CommentsCount = VeltCommentBubbleCommentsCount;
VeltCommentBubbleWireframe.UnreadIcon = VeltCommentBubbleUnreadIcon;
export default VeltCommentBubbleWireframe;
